import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

let config = {
  apiKey: 'AIzaSyBe1WJdjqAgrRJuO9CMGxw7zYtAjpRzDLg',
  authDomain: 'hexa-v2.firebaseapp.com',
  databaseURL: 'https://hexa-v2.firebaseio.com',
  projectId: 'hexa-v2',
  storageBucket: 'hexa-v2.appspot.com',
  messagingSenderId: '408984860231',
  appId: '1:408984860231:web:47cf8068d0dfaa5cc9e362',
  measurementId: 'G-BTPXTQZ46F'
};

if (process.env.NODE_ENV === 'development') {
  config = {
    apiKey: 'AIzaSyCN1lA2LaDxLHxBL5jBvVcNiii_cTb9FYQ',
    authDomain: 'hexa-v2-developer.firebaseapp.com',
    databaseURL: 'https://hexa-v2.firebaseio.com',
    projectId: 'hexa-v2-developer',
    storageBucket: 'hexa-v2-developer.appspot.com',
    messagingSenderId: '881025293871',
    appId: '1:881025293871:web:938256d2245b3ce09c30da',
    measurementId: 'G-K52TJ4PT7E'
  };
}

firebase.initializeApp(config);

export default firebase;
